export enum FiatAccountType {
  ach = 'ACH',
  rtp = 'RTP',
  swift = 'SWIFT',
  sepa = 'SEPA',
  wire = 'WIRE',
  pix = 'PIX',
  cop = 'COP',
  spei = 'SPEI',
  cvu = 'CVU',
  crypto = 'CRYPTO',
  cnaps = 'CNAPS',
  chats = 'CHATS',

  // Thunes local-corridor UI buckets — one per recipient form shape.
  // Discriminated by enum value here; the backend rail (PaymentRailType) is
  // the same string except for `bobAch` (rail=ACH; we disambiguate from US ACH
  // because the form fields differ).
  fasterPayments = 'FASTER_PAYMENTS',
  imps = 'IMPS',
  instapay = 'INSTAPAY',
  rtc = 'RTC',
  promptpay = 'PROMPTPAY',
  biFast = 'BI_FAST',
  ghipss = 'GHIPSS',
  pesalink = 'PESALINK',
  fast = 'FAST',
  eft = 'EFT',
  tef = 'TEF',
  nip = 'NIP',
  cce = 'CCE',
  ipp = 'IPP',
  bobAch = 'BOB_ACH',
  mobileWallet = 'MOBILE_WALLET',

  unset = '',
}
